import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@farewill/ui'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

const StyledLockupWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 22px;
`

const BatterseaXFarewillLogo = () => (
  <StyledLockupWrapper noTrim>
    <a
      aria-label="Visit Battersea Dogs & Cats homepage"
      href="https://www.battersea.org.uk/"
    >
      <img
        alt="Battersea Dogs & Cats Home"
        height="55"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/battersea/logo.svg`}
      />
    </a>
    <a aria-label="Visit Farewill's homepage" href="https://farewill.com">
      <img
        alt="Battersea Dogs & Cats Home"
        height="40"
        src={`${CLOUDINARY_ROOT_PATH}/fl_sanitize/cobranding-partner-logos/x-Farewill.svg`}
      />
    </a>
  </StyledLockupWrapper>
)

export default BatterseaXFarewillLogo
